import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=32b3f0bf&"
import script from "./ProductDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDetail.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./ProductDetail.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "ec97a3f8"
  
)

export default component.exports